import { ResponseObject } from '@/types/shared'
import datacentral from '@/utils/axios/datacentral'

export const presignedUrl = async ({
    key,
    prefix,
    isPublic,
}: {
    prefix: string
    key: string
    isPublic: boolean
}): Promise<ResponseObject<{ url: string; key: string }>> => {
    const response = await datacentral.post(`/uploads/presigned-url`, {
        isPublic,
        key,
        prefix,
    })
    return response.data
}
